// playersRepository.js
// API repository for players-related backend calls
import { buildApiUrl } from './apiUtils.js';

export const PlayersRepository = {
    async searchPlayers(query) {
        const params = new URLSearchParams();
        if (query) {
            params.append('query', query);
        }
        const response = await fetch(`${buildApiUrl('/players')}?${params.toString()}`, {
            method: 'GET',
            headers: { 'Accept': 'application/json' }
        });
        if (!response.ok) throw new Error('Błąd wyszukiwania graczy: ' + response.statusText);
        const data = await response.json();
        return data.players || [];
    }
};

export default PlayersRepository;
